/* eslint-disable @typescript-eslint/camelcase */
import React, { useCallback, useRef, useState } from 'react';
import { Field as FormikField, useField } from 'formik';
import { Editor } from '@tinymce/tinymce-react';
import { FormField } from '../../../types/general';
import * as FieldsProps from '../../../types/fields';
import './Input.scss';
import BundledEditor from './tinymce/BundledEditor';
import './tinymce/it.js';

export type Props = FormField;

/**
 * Generic input type
 */
const Wysiwyg: React.FC<Props> = (props) => {
	const { schema } = props;
	const { name, fieldType, props: fieldProps } = schema;
	const { readonly, disabled } = (fieldProps as FieldsProps.Input) || {};
	const [field, meta, helpers] = useField(name);

	const { value } = field;
	const { setValue } = helpers;

	const [initialValue, setInitialValue] = useState(value);

	const editorRef = useRef<any>(null);
	// methods
	const handleChange = useCallback(() => {
		if (editorRef.current) {
			setValue(editorRef.current.getContent());
		}
	}, []);

	return (
		<div key={`field-${name}`} className='Field-wysiwyg'>
			<BundledEditor
				onInit={(evt, editor) => (editorRef.current = editor)}
				onChange={handleChange}
				initialValue={initialValue}
				init={{
					language: 'it',
					height: 250,
					menubar: false,
					plugins: [
						'advlist',
						'autolink',
						'lists',
						'link',
						'image',
						'charmap',
						'anchor',
						'searchreplace',
						'visualblocks',
						'code',
						'fullscreen',
						'insertdatetime',
						'media',
						'table',
						'preview',
						'help',
						'wordcount',
					],
					toolbar:
						'bold italic underline blockquote strikethrough | ' +
						'bullist numlist | ' +
						'alignleft aligncenter alignright alignjustify | ' +
						'undo redo | pastetext link fullscreen',
					content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
					forced_root_block: 'div',
				}}
			/>
		</div>
	);
};

export default Wysiwyg;
